export const INTERESTS = [
  {
    id: "technology",
    nameKey: "aboutPage.interests.technology",
    icon: "/images/interests/technology.png",
  },
  {
    id: "art",
    nameKey: "aboutPage.interests.art",
    icon: "/images/interests/art.png",
  },
  {
    id: "literature",
    nameKey: "aboutPage.interests.literature",
    icon: "/images/interests/literature.png",
  },
  {
    id: "gaming",
    nameKey: "aboutPage.interests.gaming",
    icon: "/images/interests/gaming.png",
  },
  {
    id: "cooking",
    nameKey: "aboutPage.interests.cooking",
    icon: "/images/interests/cooking.png",
  },
  {
    id: "gardening",
    nameKey: "aboutPage.interests.gardening",
    icon: "/images/interests/gardening.png",
  },
]

export const PROGRAMS = [
  {
    id: 5,
    programFromKey: "aboutPage.program.fullStackMERN.from",
    programTitleKey: "aboutPage.program.fullStackMERN.title",
    programDate: "2024",
  },
  {
    id: 4,
    programFromKey: "aboutPage.program.javascriptReact.from",
    programTitleKey: "aboutPage.program.javascriptReact.title",
    programDate: "2023",
  },
  {
    id: 3,
    programFromKey: "aboutPage.program.teamLeader.from",
    programTitleKey: "aboutPage.program.teamLeader.title",
    programDate: "2013",
  },
  {
    id: 2,
    programFromKey: "aboutPage.program.conflictManagement.from",
    programTitleKey: "aboutPage.program.conflictManagement.title",
    programDate: "2013",
  },
  {
    id: 1,
    programFromKey: "aboutPage.program.BTS.from",
    programTitleKey: "aboutPage.program.BTS.title",
    programDate: "2000",
  },
]
